/**
 * MainCharChangeTempl Template
 * @category lineage2common
 */
class MainCharChangeTempl {
    /**
     * MainCharChangeTempl Templ
     * @param  {Object} _d={}
     */
    static getTempl(_d = {}) {
        return _d.map((_item, _idx) => {
            return `
            <li>
                <span>${_item[0].serverName}</span>
                <ul class="l2-character-list" style="display: none;">${_item.map( MainCharChangeTempl.item ).join('')}</ul>
            </li>`;
        }).join('');
    }

    static item(_d = {}, _idx = {}) {
        return `
        <li data-serverid="${_d.serverId}" data-characterid="${_d.characterId}">
            <span>${_d.name} | Lv ${_d.level} | ${_d.class}</span>
        </li>`;
    }

} // end of class


export default MainCharChangeTempl;